module.exports = __webpack_public_path__ + "static/site-8485378577bd2ed1b1eabd673879f42e.png";